
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetobhimashankar() {



  const cardData =
  {
    keyword: ' Pune to Bhimashankar Jyotirlinga Bus Hire in Pune',
    heading: 'Vaishnavi Travels: Pune to Bhimashankar Jyotirlinga Bus Hire in Pune',
    headingDescription: 'Vaishnavi Travels provides reliable and affordable Pune to Bhimashankar Jyotirlinga Bus Hire in Pune, perfect for pilgrims, families, school groups, and corporate outings. Our buses are well-maintained with spacious seating, powerful air-conditioning, and ample luggage space, ensuring a smooth and comfortable ride on the Pune–Bhimashankar route. With professional drivers, punctual pickups, and flexible booking options, we make your pilgrimage convenient and stress-free. Whether it’s a one-day darshan or a group yatra, Vaishnavi Travels guarantees safe, dependable, and comfortable bus rental services from Pune to Bhimashankar Jyotirlinga.',

    top: 'Top Places to Visit in Bhimashankar with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "Bhimashankar Temple, nestled in the Sahyadri hills about 110 km from Pune, is one of the 12 Jyotirlingas of Lord Shiva. Built in the Nagara style of architecture, it holds immense religious significance for devotees. The black stone shrine is surrounded by thick forests, creating a serene spiritual atmosphere. Pilgrims believe that worshipping here removes obstacles and grants blessings. The temple is especially crowded during Mahashivratri and Shravan. Bhimashankar is the spiritual heart of the region and a divine pilgrimage destination."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "The Bhimashankar Wildlife Sanctuary, spread over 130 sq km, surrounds the temple and is home to diverse flora and fauna. It is famous for the endangered Indian Giant Squirrel (Shekru), Maharashtra’s state animal. Trekkers and nature lovers enjoy exploring its dense forests, waterfalls, and bird-watching trails. The sanctuary is rich in medicinal plants and biodiversity, making it an ecological hotspot. Misty weather in monsoon adds charm to the trekking experience. Bhimashankar Wildlife Sanctuary is the perfect blend of devotion and nature."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake, located within the sanctuary, is a peaceful natural spot surrounded by lush greenery. Legend says Lord Hanuman once visited this place, adding to its spiritual significance. Visitors enjoy picnics, bird-watching, and short hikes around the lake. The calm water and refreshing environment make it a favorite among families. During monsoon, the surroundings become even more enchanting. Hanuman Lake is Bhimashankar’s serene retreat in nature."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a hidden shrine located deep in the forests, believed to be the place where Lord Shiva appeared in another form. Trekkers and devotees enjoy the adventure of reaching this offbeat spot through lush trails. The small shrine offers a tranquil and mystical atmosphere. It is less crowded, ideal for meditation and peaceful worship. The journey itself is filled with scenic beauty and natural wonders. Gupt Bhimashankar is Bhimashankar’s spiritual gem tucked away in nature."
  },
  {
    "title": "Nagphani Point",
    "description": "Nagphani Point, also known as Duke’s Nose, is a popular viewpoint near Bhimashankar. It offers panoramic views of the Sahyadri ranges and valleys below. The cliff is shaped like a snake’s hood, hence the name Nagphani. Trekkers and adventure enthusiasts love climbing up here for sunrise and sunset views. Monsoon clouds and mist add magical beauty to the spot. Nagphani Point is Bhimashankar’s adventure and photography hotspot."
  },
  {
    "title": "Bombay Point",
    "description": "Bombay Point is a viewpoint in Bhimashankar that offers spectacular views of the surrounding hills and valleys. It got its name as the path once led towards Bombay (Mumbai). Tourists enjoy spending evenings here, watching the sun dip behind the Sahyadris. The cool breezes and scenic landscapes make it a refreshing spot for relaxation. It is also a favorite stop for trekkers and hikers. Bombay Point is Bhimashankar’s scenic escape for nature lovers."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat is a picturesque mountain pass and trekking destination near Bhimashankar. The trek takes adventurers through dense forests, waterfalls, and charming tribal villages. From the top, the view of the Konkan plains and surrounding hills is breathtaking. The route is popular among seasoned trekkers for its challenging yet rewarding trails. Monsoon turns it into a paradise with greenery and mist. Ahupe Ghat is Bhimashankar’s thrilling trekking and scenic adventure spot."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "description": "Bhimashankar is a haven for trekkers with multiple trails cutting through the Sahyadri ranges. Popular routes include those from Khandas, Karjat, and Ahupe. Trekkers pass through waterfalls, streams, and dense forests filled with exotic birds and wildlife. The trails vary from easy to moderately challenging, catering to all adventure levels. Monsoon and winter are the best seasons for trekking. These trails make Bhimashankar Maharashtra’s adventure and pilgrimage hotspot."
  },
  {
    "title": "Sacred Groves of Bhimashankar",
    "description": "Bhimashankar is also famous for its sacred groves, protected forest patches revered by local tribes. These groves are believed to be blessed by deities and remain untouched for centuries. They are rich in biodiversity, housing rare plants and animals. Visitors find the groves mystical and spiritually uplifting. The tradition reflects the harmony between religion and ecology. Sacred Groves are Bhimashankar’s living heritage of faith and conservation."
  },
  {
    "title": "Tribal Villages Around Bhimashankar",
    "description": "Several tribal villages surround Bhimashankar, offering visitors a glimpse into simple rural life. The villagers are warm and welcoming, often selling handmade crafts, honey, and local produce. Tourists enjoy cultural exchanges, folk tales, and traditional food. During festivals, the villages come alive with music and dances. Visiting these villages adds depth to the pilgrimage experience. Tribal life is Bhimashankar’s cultural soul that complements its natural and spiritual charm."
  }
],

"services": [
  {
    "name": "Bhimashankar Temple Bus Pune",
    "description": "Dedicated bus rental service from Pune to Bhimashankar Temple, one of the revered Jyotirlingas in India. Ideal for pilgrims, family groups, school excursions, and spiritual retreats, this service includes experienced drivers familiar with temple routes, well-maintained buses, and flexible timings. Whether you're planning a one-day darshan or an extended stay, our Bhimashankar temple bus ensures a safe, punctual, and comfortable journey through scenic ghats and rural landscapes."
  },
  {
    "name": "AC Bus for Bhimashankar Trip",
    "description": "Travel in comfort with our AC bus rentals for Bhimashankar trips from Pune. These air-conditioned buses are perfect for long drives through winding hill roads, offering relief from heat and humidity. Equipped with reclining seats, clean interiors, onboard storage, and courteous drivers, this service is best suited for group pilgrimages, senior citizen tours, and family getaways who value comfort and hygiene during religious travel."
  },
  {
    "name": "Non AC Bus Hire to Bhimashankar",
    "description": "Economical Non-AC bus rental from Pune to Bhimashankar, suited for groups looking for budget-friendly transport options. These buses are well-ventilated and ideal for cooler seasons or early morning departures. Recommended for school trips, local organizations, or pilgrims who prefer open airflow over air conditioning. Buses are driven by experienced drivers familiar with the ghats and temple routes."
  },
  {
    "name": "Bhimashankar Pilgrimage Bus Rental",
    "description": "Specialized pilgrimage bus hire for Bhimashankar Jyotirlinga Yatra from Pune. We provide route planning, temple stopovers, and early arrival scheduling to avoid crowds. Buses are available in 17, 32, 40, and 50 seater variants. Services include group seating arrangements, devotional music onboard, and prayer breaks upon request. Perfect for spiritual tour operators and religious institutions."
  },
  {
    "name": "Group Bus Pune to Bhimashankar",
    "description": "Group travel bus rental service from Pune to Bhimashankar for families, friends, or spiritual communities. Our fleet includes AC and Non-AC options, with various seat capacities to match group size. Includes optional pick-up and drop points across Pune. A cost-effective and coordinated solution for transporting multiple people together to the sacred site, with full safety and convenience."
  },
  {
    "name": "Religious Bus Hire Pune",
    "description": "Hire buses in Pune for religious purposes such as Bhimashankar, Ashtavinayak, or Shirdi trips. Our buses come with devotional features like onboard bhajan systems, route coordination with temple timings, and professional drivers trained in pilgrimage travel. Whether it's a small prayer group or a full congregation, we ensure reliable religious transportation across Maharashtra."
  },
  {
    "name": "32/40 Seater Bus Bhimashankar Trip",
    "description": "Spacious 32 and 40 seater bus options for Bhimashankar temple trips from Pune, ideal for medium to large groups. These buses feature ample legroom, cushioned seats, luggage racks, and are available in both AC and Non-AC variants. Recommended for school groups, office trips, or joint families making a pilgrimage. Includes flexible start times and en route assistance."
  },
  {
    "name": "Weekend Trip Bus Bhimashankar",
    "description": "Weekend getaway bus rental for Bhimashankar from Pune, perfect for short spiritual retreats and darshan visits. This package includes round-trip service, early morning departure, and return by evening or next day. Ideal for working professionals, students, and families looking to combine religious devotion with a relaxing nature escape. Available with add-ons like breakfast stops and sightseeing points."
  },
  {
    "name": "Outstation Darshan Bus Pune",
    "description": "Outstation darshan bus hire service from Pune covering Bhimashankar and other nearby temples. Ideal for 1–2 day trips, this service includes AC/Non-AC buses, tolls, and driver allowances. Our buses are equipped for long-distance travel and suited for elderly pilgrims, families, and spiritual organizations. Customize your trip with multiple temple visits, halt planning, and early temple access."
  },
  {
    "name": "School Tour Bus Bhimashankar",
    "description": "Safe and reliable school bus service from Pune to Bhimashankar for educational or cultural tours. Our buses follow school safety norms with experienced drivers, first aid kits, and route tracking. Seating ranges from 32 to 50 seats with both AC and Non-AC options. Includes coordination with school staff and planned stopovers to ensure a well-managed student trip."
  },
  {
    "name": "Family Trip Bus Hire Pune",
    "description": "Private bus rental in Pune for family trips to Bhimashankar, with flexible timings, customized halts, and round-trip convenience. Whether it’s for a small family group or extended relatives, our 17–50 seater buses cater to various needs. Onboard comfort, experienced drivers, and secure luggage space make it ideal for all age groups. Optional features include devotional playlists and light snacks."
  },
  {
    "name": "Bus Booking Bhimashankar Pune",
    "description": "Quick and easy bus booking service for Bhimashankar trips from Pune. Choose from AC/Non-AC, various seating capacities, and real-time availability. Book online or offline with transparent pricing, route support, and live assistance. Ideal for last-minute darshan plans, group outings, or scheduled spiritual tours. Guaranteed clean buses and verified drivers for safe travel."
  },
  {
    "name": "Driver-Included Bus Bhimashankar",
    "description": "Bus rental for Bhimashankar with experienced driver included, ensuring a stress-free travel experience from Pune. Drivers are knowledgeable about temple hours, parking areas, and scenic spots en route. Available for half-day, full-day, or multi-day hire depending on your trip needs. No hidden fees—includes driver allowance, fuel, and tolls. Ideal for groups unfamiliar with hill driving routes."
  }
],
"tableData": [
  ["Bhimashankar Temple Bus Pune", "AC Bus for Bhimashankar Trip"],
  ["Non AC Bus Hire to Bhimashankar", "Bhimashankar Pilgrimage Bus Rental"],
  ["Group Bus Pune to Bhimashankar", "Religious Bus Hire Pune"],
  ["32/40 Seater Bus Bhimashankar Trip", "Weekend Trip Bus Bhimashankar"],
  ["Outstation Darshan Bus Pune", "School Tour Bus Bhimashankar"],
  ["Family Trip Bus Hire Pune", "Bus Booking Bhimashankar Pune"],
  ["Driver-Included Bus Bhimashankar"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Bhimashankar Jyotirlinga Bus Hire",
    "WhyChoosedescription": "Vaishnavi Travels offers trusted and affordable bus hire services for spiritual journeys from Pune to Bhimashankar Jyotirlinga."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses are designed for long travel with cushioned seats, clean interiors, and ample legroom for a peaceful darshan trip."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly sanitized before every trip, ensuring passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Bhimashankar Trips",
    "WhyChoosedescription": "We offer hourly, full-day, or customized trip plans to suit your group size and travel schedule."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Bhimashankar Route",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Pune to Bhimashankar route, ensuring a safe and timely journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing – No Hidden Charges",
    "WhyChoosedescription": "Our all-inclusive pricing includes tolls, fuel, taxes, and driver allowance—no surprise fees at the end."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage Tours and Family Groups",
    "WhyChoosedescription": "Perfect for temple tours, family pilgrimages, senior citizen yatras, and group darshan trips to Bhimashankar."
  },
  {
    "WhyChooseheading": "24/7 Support and Hassle-Free Booking",
    "WhyChoosedescription": "Get round-the-clock customer support to help with bookings, schedule changes, and travel updates anytime."
  }
]















  }







const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer bus hire services from Pune to Bhimashankar Jyotirlinga?',
      answer: 'Yes, Vaishnavi Travels provides reliable bus hire services from Pune to Bhimashankar Jyotirlinga, ideal for religious pilgrimages, group tours, and spiritual visits.',
    },
    {
      question: 'What types of buses are available for Pune to Bhimashankar trips?',
      answer: 'We offer a variety of options including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, suitable for different group sizes and comfort preferences.',
    },
    {
      question: 'What is the approximate cost for hiring a bus from Pune to Bhimashankar Jyotirlinga?',
      answer: 'The cost typically starts from ₹6,500 for a one-day trip with a 32 seater tempo traveller. Pricing varies based on bus type, trip duration, and amenities, with customized quotes provided.',
    },
    {
      question: 'Are drivers included in the bus hire service?',
      answer: 'Yes, all rentals include experienced and licensed drivers familiar with the Pune to Bhimashankar route, ensuring safe and smooth travel.',
    },
    {
      question: 'Can the itinerary be customized for the Bhimashankar trip?',
      answer: 'Absolutely. We tailor the itinerary, stops, and timings based on your group’s preferences and schedule.',
    },
    {
      question: 'How far in advance should I book the bus for this pilgrimage?',
      answer: 'Booking 2-3 days in advance is recommended, especially during weekends and festival seasons to ensure availability.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the rental fare?',
      answer: 'Tolls, parking fees, driver allowances, and permits are generally extra and will be clearly communicated during booking.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Ramesh Kulkarni",
    position: "Pilgrimage Group Leader",
    feedback:
      "Our trip to Bhimashankar Jyotirlinga was seamless thanks to Vaishnavi Travels. The bus was comfortable and clean, and the driver was professional and knowledgeable about the route.",
    rating: 5,
  },
  {
    name: "Mrs. Aarti Deshpande",
    position: "Religious Tour Organizer",
    feedback:
      "Vaishnavi Travels provided excellent service for our pilgrimage to Bhimashankar. The 40 seater AC bus was well-maintained, and the driver was courteous and punctual. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];



























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Jyotirlinga Bus Hire",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-bhimashankar-bus.jpg",
  "description": "Book Pune to Bhimashankar Jyotirlinga bus hire with Vaishnavi Travels. Choose from AC and Non AC buses for religious trips, group travel, and weekend getaways with driver included.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "970"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3300",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-bhimashankar-jyotirlinga-bus-hire"
  }
};


  return (
    <div>


<Helmet>
  <title>Pune to Bhimashankar Jyotirlinga Bus Hire | AC & Non AC Pilgrimage Bus | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Bhimashankar Jyotirlinga bus hire with Vaishnavi Travels. Choose from AC and Non AC buses for religious trips, group travel, and weekend getaways with driver included."
  />
  <meta
    name="keywords"
    content="Bhimashankar Temple Bus Pune, AC Bus for Bhimashankar Trip, Non AC Bus Hire to Bhimashankar, Bhimashankar Pilgrimage Bus Rental, Group Bus Pune to Bhimashankar, Religious Bus Hire Pune, 32/40 Seater Bus Bhimashankar Trip, Weekend Trip Bus Bhimashankar, Outstation Darshan Bus Pune, School Tour Bus Bhimashankar, Family Trip Bus Hire Pune, Bus Booking Bhimashankar Pune, Driver-Included Bus Bhimashankar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankar;